<template>
  <router-view v-slot="{ Component }">
    <component :is="Component" v-model="campaignGroup" @[reloadEvent(Component)]="reload" />
  </router-view>
</template>

<script lang="ts" setup>
import {computed, provide} from 'vue';
import { useRoute } from 'vue-router';
import { useFetchQuery } from '@/hooks/fetch';
import { syncHeader } from '@/components/structure/navigation/injects';
import type { CampaignGroup } from '@/entities/Entities';
import { syncPageBusy } from '@/components/utils/busy/injects';
import GlobalRegionFilter from '@utils/globalFilter/GlobalRegionFilter.vue';
import {useQueryRef} from '@hooks/url';
import globalFilterKey from '@utils/globalFilter/injects';

const route = useRoute();
const {
  data: campaignGroup,
  loading,
  refetch,
} = useFetchQuery<CampaignGroup>(`/campaign_groups/${route.params.campaignGroupId}`);

syncPageBusy(loading);

const title = computed(() => campaignGroup.value?.name ?? '');

const reloadEvent = (component: any) => (component.type.emits?.includes('reload') ? 'reload' : '');

const globalFilterValue = useQueryRef('globalFilter', {});
provide(globalFilterKey, globalFilterValue);

syncHeader(campaignGroup, (newCampaign) => ({
  extraBreadcrumbs: [
    computed(() => ({
      label: title.value,
      link: {
        name: 'campaign-group-details',
        params: { campaignGroupId: campaignGroup.value?.id ?? '-' },
      },
    })),
  ],
  title: computed(() => ({
    text: title.value,
    link: { name: 'campaign-groups' },
  })),
  globalFilterComponent: {
    component: GlobalRegionFilter,
    props: {
      campaignGroup: computed(() => campaignGroup.value),
      modelValue: globalFilterValue,
    },
    events: {
      'update:model-value': (e: string[]) => { globalFilterValue.value = e; },
    }
  },
}));

const reload = async () => {
  await refetch();
};
</script>

<style lang="scss" scoped></style>
